import React, { useState,useEffect } from "react";
import { Link } from "gatsby";

import leftArrow from "../../images/arrow--left.svg";
import rightArrow from "../../images/arrow--right.svg";

import contractImage from "../../img/contract-templates-1.jpeg";
import dappImage from "../../img/dapp-1.jpeg";

const data = {
		content: {
			key: 0,
			title: "See Examples",
			elements: [
				{
					link: "/orchestration",
					linkText: "Learn more",
					category: "Orchestration",
					title: "Learn to </br> Orchestrate",
					excerpt:
						"Build feature-rich applications that can orchestrate assets and services across the interchain.",
					image: dappImage,
				},
				{
					link: "https://docs.agoric.com",
					linkText: "Explore Docs",
					category: "Explore Docs",
					title: "Try Your Hand At Building",
					excerpt:
						"Your gateway to mastering decentralized app development, ensuring a smoother, faster experience.",
					image: contractImage,
				},
				{
					link: "https://agoric.com/newsletter",
					linkText: "Join Newsletter",
					category: "Join Newsletter",
					title: "Receive Updates In Your Inbox",
					excerpt:
						"Your direct line to the latest in JavaScript smart contracts, web3 programming insights, and our latest product news.",
					image: dappImage,
				},
				{
					link: "https://agoric.com/office-hours",
					linkText: "Attend Office Hours",
					category: "Attend Office Hours",
					title: "Say Hello To\n" +
						"Our Community",
					excerpt:
						"Dive deep, engage with our vibrant community, and amplify your decentralized know-how..",
					image: contractImage,
				},
			],
		},
	};

export default function UpcomingEvents(props) {
	let currentSlideIndex = 0;
	let slideSize = data.content.elements.length;
	let elementSize = 0;

	const [marginLeft, setMarginLeft] = useState(0);

	function slideLeft() {
		if (currentSlideIndex >= 1) {
			currentSlideIndex--;
		}
		slide();
	}
	function slideRight() {
		if (currentSlideIndex < slideSize) {
			currentSlideIndex++;
		}
		slide();
	}

	function slide() {
		setMarginLeft(-currentSlideIndex * elementSize);
	}

	const renderLink = (target, value) => {
		if (/(http(s?)):\/\//i.test(target.toLowerCase())) {
			return (
				<a href={target} className='more' target={'_blank'}>
					<i className='fas fa-arrow-right'/> {value}
				</a>
			)
		}

		return (
			<Link to={target} className='more'>
				<i className='fas fa-arrow-right'/> {value}
			</Link>
		)
	}

	useEffect(() => {
		elementSize = document.getElementsByClassName("slider-col")[0].offsetWidth;

		if (window.addEventListener) {
			window.addEventListener(
				"resize",
				function () {
					elementSize = document.getElementsByClassName("slider-col")[0].offsetWidth;
				},
				true
			);
		}
	}, [slideLeft, slideLeft]);

	return (

		<section className='examples slider-container'>
			<div className='container'>
				<div className='decorate-container'>
					<div className='decorate'>
						<span className='decorate__item' />
						<span className='decorate__item' />
					</div>
				</div>
				<div className='row examples--header section--header'>
					<div className='col-lg-6'>
						<h2>{data.content.title}</h2>
					</div>
				</div>

				<div className='row example-carousel'>
					<div className='col-12 order-2 order-lg-1 button-group'>
						<div className='slider--arrows mobile'>
							<button className='arrow arrow-left' onClick={() => slideLeft()}>
								<img src={leftArrow} alt='' />
							</button>
							<button className='arrow arrow-right' onClick={() => slideRight()}>
								<img src={rightArrow} alt='' />
							</button>
						</div>
					</div>
					<div className='col-lg-12 order-1 order-lg-2'>
						<div className='slider examples--slider'>
							<div className='slider--content'>
								<div className='slider'>
									<ul className='slider-row' style={{ marginLeft: marginLeft }}>
										{data.content.elements.map((example, index) => {
											return (
												<li key={index} className='slider-col'>
													<div
														className='example-box'
														style={{
															backgroundImage: `url(${example.image})`,
														}}
													>
														<div className='tag'>{example.category}</div>
														<h3 dangerouslySetInnerHTML={{__html: example.title}}></h3>
														<p>{example.excerpt}</p>
														{renderLink(example.link, example.linkText)}
													</div>
												</li>
											);
										})}
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
